import { render, staticRenderFns } from "./AppBarRouterView.vue?vue&type=template&id=47538ada&"
import script from "./AppBarRouterView.vue?vue&type=script&lang=js&"
export * from "./AppBarRouterView.vue?vue&type=script&lang=js&"
import style0 from "./AppBarRouterView.vue?vue&type=style&index=0&id=47538ada&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports